export var extractSummary = function extractSummary(jsonLd) {
  return jsonLd.summary;
};